import { Image, StyleSheet, View } from "@react-pdf/renderer";
import { t } from "i18next";

import { Title } from "src/core/components/pdf/shared/Title";

const styles = StyleSheet.create({
  container: {
    marginTop: 24,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 16,
    color: "#0A1A53",
  },
  graphImageWrapper: {
    width: "100%",
    height: 350,
    marginTop: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  graphImage: {
    height: "100%",
    width: "auto",
    objectFit: "contain",
  },
});

type GraphSectionProps = {
  /** Image PNG du graphe (data URL) */
  graphImageDataUrl?: string | null;
};

export const GraphSection = ({ graphImageDataUrl = null }: GraphSectionProps) => {
  return (
    <View style={styles.container}>
      <Title title={t("pdf.graph.title")} />

      {graphImageDataUrl && (
        <View style={styles.graphImageWrapper}>
          <Image src={graphImageDataUrl} style={styles.graphImage} />
        </View>
      )}
    </View>
  );
};
